module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_6005.094b9e97.png";